import { lazy } from 'react'
import { Navigate, type RouteObject } from 'react-router-dom'
import { PrivateRoute } from '@/components/routing/PrivateRoute'
import { suspensePage } from '@/routes/suspensePage'

const DashboardPage = lazy(() => import('@/pages/dashboard/DashboardPage'))
const BrowsePage = lazy(() => import('@/pages/browse/BrowsePage'))
const CardsPage = lazy(() => import('@/pages/browse/CardsPage'))
const SealedProductsPage = lazy(() => import('@/pages/browse/SealedProductsPage'))
const CardDetailPage = lazy(() => import('@/pages/browse/CardDetailPage'))
const SealedProductDetailPage = lazy(() => import('@/pages/browse/SealedProductDetailPage'))
const ListPage = lazy(() => import('@/pages/list/ListPage'))
const Buylist = lazy(() => import('@/pages/list/Buylist'))
const Selllist = lazy(() => import('@/pages/list/Selllist'))
const DecksPage = lazy(() => import('@/pages/decks/DecksPage'))
const DeckBuilderPage = lazy(() => import('@/pages/decks/DeckBuilderPage'))
const BindersListPage = lazy(() => import('@/pages/binders/BindersListPage'))
const BinderEditorPage = lazy(() => import('@/pages/binders/BinderEditorPage'))
const SubscriptionsPage = lazy(() => import('@/pages/subscriptions/SubscriptionsPage'))
const AccountSettingsPage = lazy(() => import('@/pages/settings/AccountSettingsPage'))

const browseRoutes: RouteObject = {
  path: 'browse',
  children: [
    {
      element: suspensePage(BrowsePage),
      children: [
        { index: true, element: <Navigate to="cards" replace /> },
        { path: 'cards', element: suspensePage(CardsPage) },
        { path: 'sealed', element: suspensePage(SealedProductsPage) },
      ],
    },
    { path: 'cards/:id', element: suspensePage(CardDetailPage) },
    { path: 'sealed/:id', element: suspensePage(SealedProductDetailPage) },
  ],
}

const listRoutes: RouteObject = {
  path: 'list',
  element: suspensePage(ListPage),
  children: [
    { index: true, element: <Navigate to="buy" replace /> },
    { path: 'buy', element: suspensePage(Buylist) },
    { path: 'sell', element: suspensePage(Selllist) },
  ],
}

/** Routes that require a signed-in user, rendered inside the app shell. */
export const privateRoutes: RouteObject = {
  element: <PrivateRoute />,
  children: [
    { index: true, element: suspensePage(DashboardPage) },
    browseRoutes,
    listRoutes,
    { path: 'decks', element: suspensePage(DecksPage) },
    { path: 'decks/new', element: suspensePage(DeckBuilderPage) },
    { path: 'decks/:id', element: suspensePage(DeckBuilderPage) },
    { path: 'binders', element: suspensePage(BindersListPage) },
    { path: 'binders/:id', element: suspensePage(BinderEditorPage) },
    { path: 'subscriptions', element: suspensePage(SubscriptionsPage) },
    { path: 'settings', element: suspensePage(AccountSettingsPage) },
  ],
}
